export default __webpack_public_path__ + "static/media/p1_optimal5.87a10270.gif";